/* components/CollectionActiveFilters
- Used within collection and search templates

*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionActiveFilters extends ThemeComponent {

}
